import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { baseUrl } from "./apiConfig";
import { App } from "./App";
import { AppProvider } from "./AppProvider";
import { initTranslator } from "./locales";

initTranslator(baseUrl);

ReactDOM.createRoot(document.getElementById("root")).render(
  <AppProvider>
    <App />
  </AppProvider>
);
